import { NgModule } from '@angular/core';
import { SnackBarModule } from '@epicuro-next/ataraxia/snack-bar';
import { DataEngagementApiModule } from '@epicuro-next/data/engagement/engagement-api';
import { AccountsStateModule } from '@epicuro-next/state/accounts-state';
import { PBasketStateModule } from '@epicuro-next/state/p-basket-state';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import {
  ListProductReferenceEntitiesEffects,
  LIST_PRODUCT_REFERENCE_ENTITIES_STATE_KEY,
  reducer,
  initialState,
} from './state';
import { resetStateMetaReducer } from '@epicuro-next/state/meta-reducers';

@NgModule({
  imports: [
    StoreModule.forFeature(LIST_PRODUCT_REFERENCE_ENTITIES_STATE_KEY, reducer, {
      metaReducers: [resetStateMetaReducer(initialState)],
    }),
    EffectsModule.forFeature([ListProductReferenceEntitiesEffects]),
    SnackBarModule,
    PBasketStateModule,
    DataEngagementApiModule,
    AccountsStateModule,
  ],
})
export class ListProductReferenceEntitiesModule {}
